const {Toast} = require('toaster-js/umd.js');

let cancelToken;

window.modal_callbacks = {
    replace: function (response) {
        for (let selector in response.replace) {
            let element = document.querySelector(selector);
            if (element) {
                element.innerHTML = response.replace[selector];

                $(selector).trigger('refresh');
                // const refreshEvent = new Event('refresh');
                // element.dispatchEvent(refreshEvent);
            }
        }
    },
    replaceSelf: function (response) {
        $.each(response.replace, function (selector, content) {
            $(selector).replaceWith(content);
            $(selector).trigger('refresh');
        });
    },
    options: function (response) {
        $.each(response.options, function (selector, content) {
            let $select = $(selector);
            $select.find('option').remove();
            $select.find('optgroup').remove();
            $select.append($("<option>", {text: 'Please select', value: ''}));
            $.each(content, function (id, text) {
                $select.append($("<option>", {text: text, value: id}));
            });
        });
    },
    append: function (response) {
        $.each(response.append, function (selector, content) {
            $(selector).append(content);
        });
    },
    remove: function (response) {
        $.each(response.remove, function (selector) {
            $(selector).remove();
        });
    },
    hide: function (response) {
        $.each(response.hide, function (i, selector) {
            $(selector).css({display: 'none'});
        });
    },
    show: function (response) {
        $.each(response.show, function (i, selector) {
            $(selector).css({display: 'block'});
        });
    },
    alertMessage: function (response) {
        $('.js-alert-messages').html('<div class="alert alert-success">' + response.success + '</div>');
    },
    log: function (response) {
        console.log(response);
    },
    refresh: function (response) {
        window.location.reload();
    },
    swap: function (response) {
        if (!response.hasOwnProperty('swap')) {
            return;
        }

        let $elem = $(`[data-swap="${response.swap.id}"]`);

        let isTop = $elem.prev().length === 0;
        let isBottom = $elem.next().length === 0;

        if (response.swap.direction === 'up') {
            if ($elem.prev().length === 1) {
                $elem.insertBefore($elem.prev());
            }

            if ($elem.prev().length === 0) {
                $elem.find('.js-move-up').addClass('hide');
                $elem.next().find('.js-move-up').removeClass('hide');
            }

            if (isBottom) {
                $elem.find('.js-move-down').removeClass('hide');
                $elem.next().find('.js-move-down').addClass('hide');
            }
        } else {
            if ($elem.next().length === 1) {
                $elem.insertAfter($elem.next());
            }

            if ($elem.next().length === 0) {
                $elem.find('.js-move-down').addClass('hide');
                $elem.prev().find('.js-move-down').removeClass('hide');
            }

            if (isTop) {
                $elem.find('.js-move-up').removeClass('hide');
                $elem.prev().find('.js-move-up').addClass('hide');
            }
        }
    },
    redirect: function (response) {
        if (!response.hasOwnProperty('redirect')) {
            return;
        }

        window.location.href = response.redirect;
    },
    addClass: function (response) {
        if (!response.hasOwnProperty('addClass')) {
            return;
        }

        $.each(response.addClass, function (selector, className) {
            $(selector).addClass(className);
        });
    },
    removeClass: function (response) {
        if (!response.hasOwnProperty('removeClass')) {
            return;
        }

        $.each(response.removeClass, function (selector, className) {
            $(selector).removeClass(className);
        });
    },
    call: function (response) {
        if (!response.hasOwnProperty('call')) {
            return;
        }

        $.each(response.call, function (index, methodName) {
            let fn = window[methodName];
            if (typeof fn === 'function') {
                fn();
            }
        });
    },
    disable: function (response) {
        if (!response.hasOwnProperty('disable')) {
            return;
        }

        for (let i in response.disable) {
            document.querySelectorAll(response.disable[i]).forEach(element => {
                element.setAttribute('disabled', true);
            });
        }
    },
    dataParams: function (response) {
        if (!response.hasOwnProperty('dataParams')) {
            return;
        }

        for (let selector in response.dataParams) {
            document.querySelectorAll(selector).forEach(element => {
                for (let key in response.dataParams[selector]) {
                    element.dataset[key] = response.dataParams[selector];
                }
            });
        }
    },
    formCheck: function (response, modalId) {
        const modal = document.getElementById(modalId.replace('#', ''));
        const form = modal.querySelector('form');
        const fields = form.querySelectorAll('input,select,textarea');

        let isDirty = false;

        fields.forEach(field => {
            field.addEventListener('change', () => {
                isDirty = true;
            });
        });

        $(modalId).on('hide.bs.modal', function (e) {
            if (isDirty && !confirm('Are you sure you want to refresh? Any unsaved work will be lost.')) {
                e.preventDefault();


            }
        });

        window.onbeforeunload = (event) => {
            if (isDirty) {
                const e = event || window.event;
                // Cancel the event
                e.preventDefault();
                if (e) {
                    e.returnValue = ''; // Legacy method for cross browser support
                }
                return ''; // Legacy method for cross browser support
            }
        };
    },
}

window.modal_open = [];

window.modalHandleEvents = function (response, modalId) {
    Object.keys(response).forEach(function (key) {
        if (modal_callbacks.hasOwnProperty(key)) {
            try {
                modal_callbacks[key](response, modalId);
            } catch (e) {
                console.log(e);
            }
        }
    });
};

window.modalHandleResponse = function (response) {
    modalHandleEvents(response);

    $(document).trigger('modal:finish');

    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    $('.js-reload-me').each(function () {
        $(this).attr('src', $(this).attr('src'));
    });
};

window.modalHandleMessage = function (response) {
    $('.js-error-block').remove();
    $('.form-group').removeClass('has-error');

    if (response.data.hasOwnProperty('message')) {
        let $messageContainer = $('.js-ajax-messages');
        switch (response.data.message.type) {
            case 'success':
                $messageContainer.html(`<div class="alert alert-success">${response.data.message.value}</div>`);
                // new Toast(response.data.message.value, Toast.TYPE_INFO, Toast.TIME_LONG)
                break;
            case 'warning':
                $messageContainer.html(`<div class="alert alert-warning">${response.data.message.value}</div>`);
                // new Toast(response.data.message.value, Toast.TYPE_WARNING, Toast.TIME_LONG)
                break;
            case 'danger':
                $messageContainer.html(`<div class="alert alert-danger">${response.data.message.value}</div>`);
                // new Toast(response.data.message.value, Toast.TYPE_ERROR, Toast.TIME_LONG)
                break;
        }

        setTimeout(function () {
            $messageContainer.html('');
        }, 10000);
    }
};

window.modalHandleValidation = function (error) {
    if (error.hasOwnProperty('response') && error.response.hasOwnProperty('status') && error.response.status === 422) {
        let errors = error.response.data.errors;

        let $modalForm = $('.js-modal-form');
        if (error.response.data.hasOwnProperty('message') && $modalForm.length > 0) {
            $modalForm.find('.js-form-alert').remove();
            $modalForm.prepend(`<div class="alert alert-danger js-form-alert">${error.response.data.message}</div>`);
        }

        let $modalBody = $('.modal-body');
        if ($modalBody.length > 0) {
            $modalBody.animate({scrollTop: 0}, 100);
        }

        $('.js-error-block').remove();
        $('.form-group').removeClass('has-error');

        let prefix = $modalForm.length > 0 ? '.modal ' : '';

        $.each(errors, function (key, messages) {
            let errorKey = key.replace(/\./g, '_');
            let $helpBlock = $(`${prefix}#${errorKey}_err`);
            if ($helpBlock.length === 1) {
                $helpBlock.append(`<strong>${messages[0]}</strong>`);

                $helpBlock.closest('.form-group').addClass('has-error');
            } else {
                let $elem = $(`${prefix}#${key}`).closest('.form-group');

                $elem.addClass('has-error');

                $elem.append(`<p class="help-block js-error-block"><strong>${messages[0]}</strong></p>`);
            }
        });
    }
};

window.submitModalForm = function ($elem) {
    let $modalForm = $('.js-modal-form');
    let modalId = '#' + $modalForm.closest('.modal').attr('id');
    let formData = new FormData();
    let fields = $modalForm.serializeArray();
    let method = $elem.attr('data-method');

    $.each(fields, function (i, field) {
        formData.append(field.name, field.value);
    });

    $('textarea[data-tinymce="true"]').each(function () {
        formData.set($(this).attr('id'), tinymce.get($(this).attr('id')).getContent());
    });

    formData.append('_method', method ? method : 'POST');

    $('.js-modal-form input[type="file"]').each(function () {
        let file_data = $(this)[0].files;
        if (file_data.length === 1) {
            formData.append($(this).attr('name'), file_data[0]);
        }
    });

    $('.js-error-block').remove();
    $('.form-group').removeClass('has-error');

    $elem.attr('disabled', true);
    $elem.prepend('<i class="fas fa-spinner fa-spin"></i>');

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: $elem.attr('data-url'),
        responseType: 'json',
        data: formData,
        cancelToken: cancelToken.token,
    }).then((response) => {
        $elem.find('i').remove();
        $elem.attr('disabled', false);

        let hide = response.data.hide !== false;
        if (hide) {
            $(modalId).modal('hide');
        }

        modalHandleResponse(response.data);

        modalHandleMessage(response);

        if (grecaptcha !== undefined) {
            try {
                grecaptcha.reset();
            } catch (error) {

            }
        }
    }).catch((error) => {
        modalHandleValidation(error);

        $elem.find('i').remove();
        $elem.attr('disabled', false);

        if (grecaptcha !== undefined) {
            try {
                grecaptcha.reset();
            } catch (error) {

            }
        }
    });
};

window.displayModal = function (modalId, data) {
    $('.js-modals-container').html(data.modal);

    $(modalId).ready(function () {
        $(modalId)
            .modal({backdrop: 'static'})
            .on('shown.bs.modal', function () {
                $(document).off('focusin.modal');

                $(this).find('.js-markdown').each(function () {
                    markdownInit();
                });

                initDatepicker();
                initSelectize();

                let $gRecaptcha = $('.g-recaptcha');

                if (grecaptcha !== undefined && $gRecaptcha.length > 0) {
                    $gRecaptcha.each(function () {
                        try {
                            grecaptcha.render($(this).attr('id'), {
                                sitekey: $(this).attr('data-sitekey'),
                                theme: "light"
                            });
                        } catch (error) {
                        }
                    });
                }

                window.modal_open.forEach(func => {
                    func();
                });
            });
    });
};

window.openModalForm = function (modalId, url, $btn) {
    modalId = '#' + modalId + '-modal';

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'get',
        url: url,
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        displayModal(modalId, response.data);

        modalHandleEvents(response.data, modalId);

        if ($btn) {
            $btn.attr('disabled', false);
        }
    }).catch(() => {
        if ($btn) {
            $btn.attr('disabled', false);
        }
    });
};

window.ajaxGet = function (url, params, action) {
    let cancelToken;

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'get',
        url: url,
        responseType: 'json',
        params: params,
        cancelToken: cancelToken.token,
    }).then((response) => {
        action(response);
    }).catch((error) => {
        modalHandleValidation(error);
    });
};

window.ajaxPost = function (url, params, action) {
    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: url,
        responseType: 'json',
        data: params,
        cancelToken: cancelToken.token,
    }).then((response) => {
        action(response);
    }).catch((error) => {
        modalHandleValidation(error);
    });
};

window.doConfirm = function (elem) {
    let showConfirm = $(elem).attr('data-confirm') === 'true';
    let message = $(elem).attr('data-message');

    if (message === undefined || message === '') {
        message = "Are you sure you want to delete?";
    }

    if (!showConfirm) {
        return false;
    }

    const confirmed = confirm(message);

    return confirmed !== true;
};

window.ajaxGet = function (url, params, action) {
    let cancelToken;

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'get',
        url: url,
        responseType: 'json',
        params: params,
        cancelToken: cancelToken.token,
    }).then((response) => {
        action(response);
    }).catch((error) => {
        modalHandleValidation(error);
    });
};

window.ajaxPost = function (url, params, action) {
    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: url,
        responseType: 'json',
        data: params,
        cancelToken: cancelToken.token,
    }).then((response) => {
        action(response);
    }).catch((error) => {
        modalHandleValidation(error);
    });
};

$(document).on('click', '.js-form-modal', function (event) {
    event.preventDefault();

    $(this).attr('disabled', true);

    let modal = $(this).attr('data-modal');
    if (modal === undefined) {
        modal = 'default';
    }
    let url = $(this)[0].hasAttribute('href') && $(this).attr('href') !== '#' ? $(this).attr('href') : $(this).attr('data-url');

    let params = $(this).attr('data-params');
    if (params !== undefined) {
        url += '?' + params;
    }

    openModalForm(modal, url, $(this));
});

$(document).on('click', '.js-modal-form-button', function (event) {
    event.preventDefault();

    submitModalForm($(this));
});

$(document).on('submit', '.js-modal-form', function (event) {
    event.preventDefault();

    submitModalForm($(this).closest('.modal-content').find('.js-modal-form-button'));
});

$(document).on('click', '.js-ajax-button', function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (doConfirm(this)) {
        return;
    }

    let method = $(this).attr('data-method');
    method = (method ? method : 'POST');
    let params = $(this).attr('data-params');

    params = params ? JSON.parse(params) : {};
    params['_method'] = method;

    let $form = $(this).closest('form.js-ajax-fields');

    let formData = new FormData();
    formData.append('_method', method);

    if ($form.length > 0) {
        let fields = $form.serializeArray();

        $.each(fields, function (i, field) {
            formData.append(field.name, field.value);
        });
        $('textarea[data-tinymce="true"]').each(function () {
            formData.set($(this).attr('id'), tinymce.get($(this).attr('id')).getContent());
        });

        $form.find('input[type="file"]').each(function () {
            let file_data = $(this)[0].files;
            let $this = $(this);
            $.each(file_data, function (i, file) {
                formData.append($this.attr('name'), file, file.name);
            });
        });
    }

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    let $icon = $(this).find('i');
    let icon = $icon.length > 0 ? $icon.attr('class') : null;
    $icon.attr('class', 'fas fa-spinner fa-spin');

    let request = {
        method: method.toUpperCase() === 'GET' ? 'get' : 'post',
        url: $(this)[0].hasAttribute('href') && $(this).attr('href') !== '#' ? $(this).attr('href') : $(this).attr('data-url'),
        responseType: 'json',
        cancelToken: cancelToken.token,
    };

    if (method === 'GET') {
        request.params = params;
    } else {
        request.data = params;
    }

    axios(request).then((response) => {
        modalHandleResponse(response.data);

        modalHandleMessage(response);
    }).finally(() => {
        $icon.attr('class', icon);
    });
});

$(document).on('click', '.js-ajax-form', function (event) {
    event.preventDefault();
    event.stopPropagation();

    let $button = $(this);
    let $form = $(this).closest('form');

    let method = $(this).attr('data-method');
    let loading = $(this).attr('data-loading');

    let formData = new FormData();
    let fields = $form.serializeArray();

    $.each(fields, function (i, field) {
        formData.append(field.name, field.value);
    });
    $('textarea[data-tinymce="true"]').each(function () {
        formData.set($(this).attr('id'), tinymce.get($(this).attr('id')).getContent());
    });
    formData.append('_method', method ? method : 'POST');

    $form.find('input[type="file"]').each(function () {
        let file_data = $(this)[0].files;
        let $this = $(this);
        $.each(file_data, function (i, file) {
            formData.append($this.attr('name'), file, file.name);
        });
    });

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    let $icon = $(this).find('i');
    let icon = $icon.length > 0 ? $icon.attr('class') : null;
    $icon.attr('class', 'fas fa-spinner fa-spin');

    if(loading) {
        $(loading).html('<i class="fas fa-spinner fa-spin"></i>');
    }

    axios({
        method: 'post',
        url: $form.attr('action'),
        responseType: 'json',
        data: formData,
        cancelToken: cancelToken.token,
    }).then((response) => {
        modalHandleResponse(response.data);
        modalHandleMessage(response);

        let reset = $button[0].hasAttribute('data-reset') ? $button.attr('data-reset') === 'yes' : true;
        if (reset) {
            $form[0].reset();
        }

        $('[data-clear="true"]').each(function () {
            $(this).html('');
        });

        $icon.attr('class', icon);
    }).catch((error) => {
        modalHandleValidation(error);
    });
});

// Form Confirm
$(document).on('submit', 'form.js-confirm-popup', function (event) {
    let $canSubmit = $(this).attr('data-can-submit') === 'true';

    if (!$canSubmit) {
        event.preventDefault();

        let $modalId = $(this).attr('data-modal') + '-modal';

        $('#' + $modalId).modal('show');
    }
});

$(document).on('click', '.js-submit-form', function (event) {
    let $form = $('form.js-confirm-popup');
    $form.attr('data-can-submit', 'true');
    $form.trigger('submit');
});

$(document).ready(function () {
    $('.js-refresh').each(function () {
        let $this = $(this);
        setInterval(() => {
            axios.interceptors.request.use((config) => {
                $('.js-refresh-notification').html('<i class="fas fa-sync-alt fa-spin"></i> Refreshing');
                return config;
            });

            ajaxGet($this.attr('data-url'), {}, (response) => {
                modalHandleResponse(response.data);
                $('.js-refresh-notification').html('');
            });
        }, parseInt($(this).attr('data-check'), 10));
    });
});

window.modal_open.push(() => {
    let input = document.createElement('input');
    input.name = 'queryParams';
    input.type = 'hidden';
    input.setAttribute('value', decodeURIComponent(window.location.search));

    document.querySelector('.js-modal-form').appendChild(input);
});
